export default {


  //直接回到页面顶部
  toPageTop() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  },


  //video_info_content 转 data  (pc端 发布的内容中含有视频时)
  toVideoData(data) {
    var that = this;
    if (!that.isEmpty(data.video_info_content) && data.video_info_content.length > 0) {
      data.video_info_content.forEach((item, index) => {
        if (item.type == 1) {

          if (!this.isEmpty(item.son.value)) {
            var test = item.son.value;
            var imgArr = [];
            // test.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi, function (match, capture) {
            //   // var elImage = `<el-image class="img" :src="${capture}" :preview-src-list="[${capture}]"></el-image>`
            //   imgArr.push({
            //     obj: match,
            //     url: capture,
            //   });
            // });
            var imgContent = [];

            if (imgArr.length > 0) {
              var contentArr = [test];
              imgArr.forEach((item, index) => {

                if (imgArr.length === 1) {
                  var arr_one = test.split(item.obj);
                  imgContent.push({type: 1, value: arr_one[0],});
                  imgContent.push({type: 2, value: item.url});
                  imgContent.push({type: 1, value: arr_one[1],});
                } else {
                  if (index === 0) {
                    var arr_one = test.split(item.obj);
                    contentArr = arr_one;
                    imgContent.push({type: 1, value: arr_one[0],});
                    imgContent.push({type: 2, value: item.url});
                  } else {
                    var arr_other = contentArr[1].split(item.obj);
                    contentArr = arr_other;
                    imgContent.push({type: 1, value: arr_other[0],});
                    imgContent.push({type: 2, value: item.url});
                    if (imgArr.length - 1 === index) {
                      imgContent.push({type: 1, value: arr_other[1],});
                    }
                  }
                }
              });
            } else {
              imgContent.push({type: 1, value: test})
            }
          }

          item['html'] = item.son.value;
          item['content'] = imgContent;
        }
        else if (item.type == 3) {
          //  视频
          var playerOptions = {
            playbackRates: [0.5, 1.0, 1.5, 2.0], //播放速度
            autoplay: false, //如果true,浏览器准备好时开始回放。
            muted: false, // 默认情况下将会消除任何音频。
            loop: false, // 导致视频一结束就重新开始。
            preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
            language: 'zh-CN',
            aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
            fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
            sources: [
              {
                src: item.value,  // 路径
                type: '',  // 类型
              },
            ],
            poster: "", //你的封面地址
            // width: document.documentElement.clientWidth,
            notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
            controlBar: {
              // timeDivider: true,
              durationDisplay: true,
              remainingTimeDisplay: false,
              fullscreenToggle: true  //全屏按钮
            }
          };
          item['playerOptions'] = playerOptions;
        }
      });
    }
    return data;
  },
  //app_content 转 data
  toData(data) {
    var that = this;
    if (!that.isEmpty(data.app_content)) {
      data.app_content.forEach((item, index) => {
        if (item.type == 1) {
          var sonHtml = '';
          item.son.forEach((son, ii) => {
            //  文字
            var bold = son.is_bold == 1 ? 'bold' : 'normal';
            var italic = son.is_italic == 1 ? 'italic' : 'normal';
            var through = son.is_del_line == 1 ? 'line-through' : 'normal';
            sonHtml += `<span style="font-weight: ${bold}; font-style: ${italic}; text-decoration: ${through};">${son.value}</span>`;
          });
          item['html'] = `<p>${sonHtml}</p>`;
        } else if (item.type == 3) {
          //  视频
          if (that.isEmpty(item.value)) {
            console.log("这是一个视频")
          } else {
            var playerOptions = {
              playbackRates: [0.5, 1.0, 1.5, 2.0], //播放速度
              autoplay: false, //如果true,浏览器准备好时开始回放。
              muted: false, // 默认情况下将会消除任何音频。
              loop: false, // 导致视频一结束就重新开始。
              preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
              language: 'zh-CN',
              aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
              fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
              sources: [
                {
                  src: item.value,  // 路径
                  type: 'video/mp4'  // 类型
                }
              ],
              poster: "", //你的封面地址
              // width: document.documentElement.clientWidth,
              notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
              controlBar: {
                // timeDivider: true,
                durationDisplay: true,
                remainingTimeDisplay: false,
                fullscreenToggle: true  //全屏按钮
              }
            };
            item['playerOptions'] = playerOptions;
          }
        }
      });
    }
    return data;
  },

  //app_content 转 html
  //app_content 转 html
  toHtml(arr){
    var html = '';
    if(Array.isArray(arr)){
      arr.forEach((item, index)=>{
        if(item.type == 1){

          var sonHtml = '';
          item.son.forEach((son, ii)=>{
            //  文字
            var bold = item.is_bold == 1?'bold':'normal';
            var italic = item.is_italic == 1?'italic':'normal';
            var through = item.is_del_line == 1?'line-through':'normal';
            sonHtml += `<span style="font-weight: ${bold}; font-style: ${italic}; text-decoration: ${through};">${son.value}</span>`;
          });
          html += `<p class="mb10" >${sonHtml}</p>`;

        } else if(item.type == 2){
          //  图片
          html += `<p class="mb10"><img class="content_image" src="${item.value}" alt=""></p>`;
        } else if(item.type == 3){
          //  视频
          html += `<div class="mb10 video-div"><video style="background: #000;" controls src="${item.value}"></video></div>`;
        } else if(item.type == 4){
          //  音频
          html += `<div class="mb10 audio-div">${item.duration}"<audio controls src="${item.value}"></audio></div>`;
        }
      });
    }
    return html;
  },

  //根据登录状态获取token uid
  getToken() {
    var isRemember = localStorage.getItem('isRemember') || false;//是否记住登录状态
    var bh_token = '';
    var bh_uid = '';
    if (isRemember) {
      bh_token = localStorage.getItem('bh_token') || '';
      bh_uid = localStorage.getItem('bh_uid') || '';

      if (this.isEmpty(bh_token)) {
        bh_token = sessionStorage.getItem('bh_token') || '';
      }
      if (this.isEmpty(bh_uid)) {
        bh_uid = sessionStorage.getItem('bh_uid') || '';
      }
    } else {
      bh_token = sessionStorage.getItem('bh_token') || '';
      bh_uid = sessionStorage.getItem('bh_uid') || '';
    }
    return {token: bh_token, uid: bh_uid};
  },


  shareConfig(wx, share_href, data, share_icon){


    // share_href = share_href.replace('/#/', '/?#/');

    wx.ready(function () {

      //分享到朋友圈
      wx.onMenuShareTimeline({
        title: data.title, // 分享时的标题
        link: share_href, // 分享时的链接
        imgUrl: share_icon, // 分享时的图标
        desc: data.type_name, // 分享时的简介
        success: function (res) {
          console.log("onMenuShareTimeline-success", res)
        },
        cancel: function (error) {
          console.log("onMenuShareTimeline-error", error)
        }
      });


      //分享给朋友
      wx.onMenuShareAppMessage({
        title: data.title,// 分享时的标题
        link: share_href, // 分享时的链接
        imgUrl: share_icon, // 分享时的图标
        desc: data.type_name,// 分享时的简介
        type: 'link',
        dataUrl: '',
        success: function (res) {
          console.log("onMenuShareAppMessage-success", res)
        },
        cancel: function (error) {
          console.log("onMenuShareAppMessage-error", error)
        }
      });

      //分享到朋友圈
      wx.updateTimelineShareData({
        title: data.title, // 分享时的标题
        link: share_href, // 分享时的链接
        imgUrl: share_icon, // 分享时的图标
        desc: data.type_name, // 分享时的简介
        success: function (res) {
          console.log("updateTimelineShareData-success", res)
        },
        cancel: function (error) {
          console.log("updateTimelineShareData-error", error)
        }
      });


      //分享给朋友
      wx.updateAppMessageShareData({
        title: data.title,// 分享时的标题
        link: share_href, // 分享时的链接
        imgUrl: share_icon, // 分享时的图标
        desc: data.type_name,// 分享时的简介
        success: function (res) {
          console.log("updateAppMessageShareData-success", res)
        },
        cancel: function (error) {
          console.log("updateAppMessageShareData-error", error)
        }
      });

    })
  },


  //判断是否为空
  isEmpty(val) {
    if (val == "" || val == null || val == undefined || val == " ")
      return true;
    return false;
  },
  //倒计时
  countDown(obj, num) {
    if (num == 1) {
      var Timer = setInterval(() => {
        if (obj.code_time > 0) {
          obj.code_time--;
          obj.code_text = `${obj.code_time}秒后获取`;
          obj.code_flag = false;
        } else {
          obj.code_flag = true;
          obj.code_time = 60;
          obj.code_text = `重新获取`;
          clearInterval(Timer);
        }
      }, 1000)
    } else {
      var Timer = setInterval(() => {
        if (obj.re_code_time > 0) {
          obj.re_code_time--;
          obj.re_code_text = `${obj.re_code_time}秒后获取`;
          obj.re_code_flag = false;
        } else {
          obj.re_code_flag = true;
          obj.re_code_time = 60;
          obj.re_code_text = `重新获取`;
          clearInterval(Timer);
        }
      }, 1000)
    }

  },


  //判断是否登录
  isLogin(that) {
    if (this.isnull(that.$cookies.get("token"))) {
      return false;
    } else {
      return true;
    }
  },

  /* 是否手机号码*/
  isMobile(value) {
    const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    if (value == '' || value == undefined || value == null) {
      return false;
    } else {
      if (!reg.test(value)) {
        return false;
      } else {
        return true;
      }
    }
  },


  //时间戳  转 年月日
  add0(m) {
    return m < 10 ? '0' + m : m
  },
  format(timestamp, type) {
    //timestamp是整数，否则要parseInt转换
    var time = new Date(timestamp);
    var y = time.getFullYear();
    var m = time.getMonth() + 1;
    var d = time.getDate();
    var h = time.getHours();
    var mm = time.getMinutes();
    var s = time.getSeconds();
    if (type == 'yyyy-mm-dd') {
      return y + '.' + this.add0(m) + '.' + this.add0(d);
    } else if (type == 'mm-dd') {
      return this.add0(m) + '.' + this.add0(d);
    } else if (type == 'yyyy-mm-dd/hh:mm:ss') {
      return y + '.' + this.add0(m) + '.' + this.add0(d) + ' ' + this.add0(h) + ':' + this.add0(mm) + ':' + this.add0(s);
    }
  },

  //获取链接上参数
  getParam(variable) {
    var query = window.location.search.substring(1);
    var query3 = window.location.href.split("?");
    query = query + '&' + query3[1] + '&' + query3[2];
    console.log("param：" + query);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return (false);
  },


  //判断是否为ios
  isIOS() {
    var isIphone = navigator.userAgent.includes('iPhone');
    var isIpad = navigator.userAgent.includes('iPad');
    return isIphone || isIpad;
  },

}



// WEBPACK FOOTER //
// ./src/utils/utils.js